






















































































































































































































































































































































































































import Vue from "vue";
import { Debounce } from "vue-debounce-decorator";
import { Component, Prop, Watch } from "vue-property-decorator";
import { PriceListService } from "@/services/PriceListService";
import { ShipmentService } from "@/services/ShipmentService";
import {
  AddressShipmentDTO,
  CourierDTO,
  CourierPackageTypeDTO,
  CourierServiceDTO,
  MbeServiceDTO,
  OnlineMbePackTypeDto,
  ShipmentDTO,
  ShipmentPackageDTO
} from "@/model/data.model";
import {
  CourierAndCourierService,
  DistanceResultDef,
  GelNetworkCodeDTO,
  OnlineMbePackTypeDef,
  SearchParams,
  SelectOptionDef
} from "@/model/component.model";
import PackageDefinition from "./PackageDefinition.vue";
import ShipmentElinkModal from "./ShipmentElinkModal.vue";
import store from "@/vuex/store";
import {
  alertDangerReason,
  isFrance,
  isGermany,
  isItaly,
  isPoland
} from "@/services/Helpers";
import { CustomerService } from "@/services/CustomerService";
import DecimalNumber from "@/components/shared/DecimalNumber.vue";
import Modal from "@components/shared/modal/Modal.vue";
import GelPickupMap from "../gel/GelPickupMap.vue";
import {
  CourierBusiness,
  GLSServiceBusiness,
  MBEShipServiceBusiness
} from "@/model/enumeration.model";
import WineService from "@/services/WineService";

const notMultipackageIfNotAllowed = (value: number) => {
  return store.getters["customer/config"].multiplePackages || !(+value > 1);
};
const smallerThanMaxShipmentWeight = (value: number) => {
  value = value || 0;
  return (
    store.getters["customer/config"].maxShipmentWeight === 0 ||
    parseFloat(value.toString()) <=
      store.getters["customer/config"].maxShipmentWeight
  );
};
const notZero = (value: number) => {
  value = value || 0;
  return parseFloat(value.toString()) !== 0;
};

@Component({
  components: {
    PackageDefinition: PackageDefinition,
    ShipmentElinkModal,
    DecimalNumber,
    MbeModal: Modal,
    GelPickupMap
  },
  validations() {
    return {
      totalWeightIncludingVolumetricWeight: {
        smallerThanMaxShipmentWeight,
        notZero
      },
      shipment: {
        customerWeight: { smallerThanMaxShipmentWeight },
        shipmentPackages: {
          length: { notMultipackageIfNotAllowed }
        }
      }
    };
  }
})
export default class Calculator extends Vue {
  @Prop() shipment: ShipmentDTO;
  @Prop() edition: boolean;
  @Prop({ type: Boolean, default: false }) isDeliveryPointSelected: boolean;
  @Prop({ default: false }) detailsCalled: boolean;
  @Prop({}) mbeServiceSelected: MbeServiceDTO;
  @Prop({}) autopilotCourierId: number;
  @Prop({}) courierPackageTypes: CourierPackageTypeDTO[];
  @Prop({}) enabledAutopilotCouriers: any[];
  @Prop({ default: false }) isGel: boolean;
  @Prop({ default: false }) isWineShipment: boolean;
  @Prop({ default: "" }) wineProduct: string;
  @Prop({ default: false }) autopilotEnabled: boolean;

  totalBottles = 0;
  winePackageTypes: SelectOptionDef[] = [];
  showElinkModal = false;
  distanceFromTo = 0;
  getDistanceModalVisible = false;
  calculatedDistance: number;
  googleDistance: DistanceResultDef = {
    humanReadable: "0.0 km",
    inMeters: 0,
    hasResult: false
  };
  shipmentTemplates: any[] = [];
  selectedTemplate: any = {};
  specificPacktypes: any[];
  specificPackTypeSelected: any = {};
  handlingInstructions: any[];
  specialPackagesCourierWeightList: {
    index: number;
    courierWeight: number;
    customerWeight: number;
  }[] = [];

  allPackagesEqual = false;
  couriers: CourierDTO[] = [];
  courierServices: CourierServiceDTO[] = [];
  courierAndCourierServices: CourierAndCourierService[] = [];
  mbePackTypes: OnlineMbePackTypeDef[] = [];
  gelNetworkCodes: GelNetworkCodeDTO[] = [];

  @Watch("allPackagesEqual")
  adjustPackages() {
    if (this.allPackagesEqual) {
      this.shipment.shipmentPackages = this.shipment.shipmentPackages.map(
        (item: ShipmentPackageDTO) => {
          return JSON.parse(
            JSON.stringify(this.cloneFrom(this.shipment.shipmentPackages[0]))
          );
        }
      );
    }

    // Recalculate shipment weight from all shipment packages weight
    this.shipment.customerWeight = this.shipment.shipmentPackages
      .map(item => {
        return Number(item.customerWeight);
      })
      .reduce((a, b) => a + b, 0);
    this.shipment.courierWeight = this.shipment.customerWeight;

    this.totalBottles = this.shipment.shipmentPackages
      .map(item => Number(item.itemsNumber) || 0)
      .reduce((a, b) => a + b, 0);

    this.$emit("packageDimensionsChanged");
  }

  async loadWinePackageTypes() {
    try {
      if (!this.isWineShipment) return;
      const list = await WineService.prototype.getPackageTypes();
      this.winePackageTypes = list.map((el: string) => {
        return { value: el, label: `WINE_PACKAGE_TYPE_${el.toUpperCase()}` };
      });
    } catch (err) {
      console.error(err);
    }
  }

  mounted() {
    this.loadWinePackageTypes();
    this.loadTemplates();
  }

  @Watch("courier", { deep: true })
  onCourierChange(data: any) {
    if (!this.specialPackagesCourierWeightList.length) return;
    for (
      let index = 0;
      index < this.specialPackagesCourierWeightList.length;
      index++
    ) {
      if (!this.shipment.shipmentPackages[index]) continue;
      const el = this.specialPackagesCourierWeightList[index];
      if (data && data.idCourier) {
        if (data.idCourier === CourierBusiness.UPS) {
          this.shipment.shipmentPackages[el.index].courierWeight = Number(
            el.courierWeight
          );
        } else {
          this.shipment.shipmentPackages[el.index].courierWeight = Number(
            el.customerWeight
          );
        }
      }
    }

    this.adjustPackages();
  }

  resetAllPackages() {
    this.shipment.shipmentPackages = this.shipment.shipmentPackages.map(
      (shipmentPackage: ShipmentPackageDTO) => {
        return Object.assign(shipmentPackage, {
          courierWeight: 0,
          customerWeight: 0,
          depth: 0,
          customerVolumetricWeight: 0,
          customerTaxedWeight: 0,
          width: 0,
          height: 0,
          girth: 0,
          courierVolumetricWeight: 0,
          courierTaxedWeight: 0,
          ...(this.isWineShipment
            ? {
                itemsNumber: 0,
                specialItemsNumber: 0
              }
            : {}),
          winePackType: "STANDARD"
        });
      }
    );

    if (this.isWineShipment) {
      this.specialPackagesCourierWeightList = [];
      this.updateTotalBottles(0);
    }
  }

  updateTotalBottles(e) {
    let totalBottles;
    // Distribute entered weight in all packages
    if (typeof e == "number") {
      totalBottles = e;
    } else {
      totalBottles =
        typeof e.target.value === "number"
          ? e.target.value
          : parseFloat(e.target.value.replace(",", "."));
    }

    if (!this.allPackagesEqual && totalBottles == this.totalBottles) return;

    const MAX_BOTTLES_PER_PACKAGE = 12;
    const requiredPackages = Math.ceil(totalBottles / MAX_BOTTLES_PER_PACKAGE);
    let packages = this.shipment.shipmentPackages;
    const basePackage =
      this.allPackagesEqual && packages.length > 0
        ? JSON.parse(JSON.stringify(packages[0]))
        : {
            addHandling: null,
            oversize: null,
            overweight: null,
            sequence: 0,
            packTrackingNumber: "",
            courierWeight: 0,
            courierVolumetricWeight: 0,
            courierTaxedWeight: 0,
            customerWeight: 0,
            customerVolumetricWeight: 0,
            customerTaxedWeight: 0,
            depth: 0,
            width: 0,
            height: 0,
            packageCourierId: 0,
            packageCourierName: "",
            itemsNumber: 0,
            specialItemsNumber: 0,
            winePackType: packages[0].winePackType
          };
    if (packages.length < requiredPackages) {
      for (let i = packages.length; i < requiredPackages; i++) {
        const newPkg = JSON.parse(JSON.stringify(basePackage));
        newPkg.sequence = i + 1;
        packages.push(newPkg);
      }
    }

    let remaining = Math.floor(totalBottles);
    for (let i = 0; i < packages.length; i++) {
      const fill = Math.min(remaining, MAX_BOTTLES_PER_PACKAGE);
      packages[i].itemsNumber = fill;
      packages[i].sequence = i + 1;
      remaining -= fill;
    }

    if (requiredPackages < packages.length && requiredPackages === 0) {
      const newPkg = JSON.parse(JSON.stringify(basePackage));
      newPkg.sequence = 1;
      packages = [newPkg];
    }

    if (packages.length > 1) {
      packages = packages.filter(
        (pkg: ShipmentPackageDTO) => pkg.itemsNumber && pkg.itemsNumber > 0
      );
    }

    this.shipment.shipmentPackages = packages;
    this.totalBottles = totalBottles;

    this.adjustPackages();
  }

  swapValues(edition, isPackTypeEnvelope) {
    if (edition && !isPackTypeEnvelope) {
      this.allPackagesEqual = !this.allPackagesEqual;
      return true;
    } else {
      return false;
    }
  }

  toggleShowElinkModal() {
    this.showElinkModal = !this.showElinkModal;
  }

  get totalShipmentWeight() {
    this.couriers = this.couriers.filter(c => c.idCourier);
    return this.shipment.customerWeight;
    // if (isItaly()) {
    //   return this.shipment.customerWeight.toFixed(1).replace(".", ",");
    // } else {
    //   return this.shipment.customerWeight.toFixed(1);
    // }
  }

  changeShipmentWeight(e: any) {
    let weight;
    // Distribute entered weight in all packages
    if (typeof e == "number") {
      weight = e;
    } else {
      weight =
        typeof e.target.value === "number"
          ? e.target.value
          : parseFloat(e.target.value.replace(",", "."));
    }

    if (!this.allPackagesEqual && weight == this.totalShipmentWeight) return;

    const n = this.shipment.shipmentPackages.length;
    const package_weight = weight / n;
    this.shipment.shipmentPackages.forEach(item => {
      item.customerWeight = package_weight;
      item.courierWeight = package_weight;
    });
    this.shipment.customerWeight = weight;
    this.shipment.courierWeight = weight;
    this.adjustPackages();
  }

  get mbePackage(): OnlineMbePackTypeDef | null {
    const filteredPackageTypes = this.mbePackTypes.filter(
      (item: OnlineMbePackTypeDef) => {
        return item.packtypeBusinessId === this.shipment.shipPackTypeId;
      }
    );

    if (filteredPackageTypes.length > 0) {
      return filteredPackageTypes[0];
    } else {
      return null;
    }
  }

  set mbePackage(value: OnlineMbePackTypeDef | null) {
    if (value !== null) {
      this.shipment.shipPackTypeId = value.packtypeBusinessId;
      this.shipment.shipPackType = value.packTypeDescription;
    } else {
      this.shipment.shipPackTypeId = 0;
      this.shipment.shipPackType = "";
    }
  }

  mbePackageModified(item: OnlineMbePackTypeDef) {
    this.mbePackage = item;
    if (this.shipment.shipPackTypeId === 1) {
      this.allPackagesEqual = true;
      let val = 0; // fixed weight for envelope
      if (!isFrance()) {
        if (isGermany() && this.shipment.courierId == 4) {
          val = 0.3;
        } else {
          if (this.shipment.courierServiceId === 1604) {
            val = 0.2;
          } else {
            val = 0.5;
          }
        }
      } else {
        switch (this.shipment.courierId) {
          case 1:
            val = 2;
            break; //UPS
          case 2:
            val = 0.5;
            break; //FedEx
          case 3:
            val = 0.25;
            break; //TNT
          case 4:
            val = 0.3;
            break; //DHL
          default:
            val = 0.5;
            break;
        }
      }
      this.packageNumberModified(1); //max 1 envelope
      this.changeShipmentWeight({ target: { value: val } });
    }
    //Documents
    else if (this.shipment.shipPackTypeId === 2) {
      this.allPackagesEqual = true;
      let val = 0; // fixed weight
      if (isFrance()) {
        switch (this.shipment.courierId) {
          case 1:
            val = 2.5;
            break;
          case 2:
            val = 2.5;
            break;
          case 3:
            val = 3;
            break;
          case 4:
            val = 2;
            break;
          default:
            val = 2.5;
            break;
        }
        this.packageNumberModified(1); //max 1 envelope
        this.changeShipmentWeight({ target: { value: val } });
      } else if (isPoland()) {
        if (this.shipment.courierId === 4) {
          val = 1;
          this.packageNumberModified(1); //max 1 envelope
          this.changeShipmentWeight({ target: { value: val } });
        }
      }
    } else {
      this.allPackagesEqual = false;
    }
    this.$emit("packageTypeModified");
  }

  get courier(): CourierDTO | null {
    const filteredCourierList = this.couriers.filter((item: CourierDTO) => {
      return item.idMBEBusiness === this.shipment.courierId;
    });

    if (filteredCourierList.length > 0) {
      return filteredCourierList[0];
    } else {
      if (
        this.shipment.courierId &&
        this.shipment.courierName &&
        !this.autopilotEnabled &&
        !(
          this.shipment.mbeServiceId ===
            MBEShipServiceBusiness.GEL_PROXIMITY_POINT ||
          this.shipment.mbeServiceId === MBEShipServiceBusiness.MBE_ACCESS_POINT
        )
      ) {
        this.couriers.push({
          idMBEBusiness: this.shipment.courierId,
          idCourier: this.shipment.courierId,
          courierName: this.shipment.courierName
        } as CourierDTO);
        this.courierServices = [];
        return {
          idMBEBusiness: this.shipment.courierId,
          idCourier: this.shipment.courierId,
          courierName: this.shipment.courierName
        } as CourierDTO;
      }
      return null;
    }
  }

  set courier(value: CourierDTO | null) {
    if (value != null) {
      this.shipment.courierId = value.idMBEBusiness;
      this.shipment.courierName = value.courierName;
    } else {
      this.shipment.courierId = this.shipment.courierId
        ? this.shipment.courierId
        : 0;
      this.shipment.courierName = this.shipment.courierName
        ? this.shipment.courierName
        : null;
    }
  }

  courierModified(item: CourierDTO, manual = true) {
    if (
      !this.$store.getters.features.storeAutopilotEnabled &&
      this.$store.state.customer.config.smartChoiceSetting !== "AUTOPILOT"
    ) {
      this.loadCouriers();
    }
    this.courier = item;
    if (
      manual &&
      this.shipment.mbeService &&
      this.isGel &&
      this.shipment.addressAccessPoint
    ) {
      const blankAddress = new AddressShipmentDTO();
      blankAddress.contact = this.shipment.addressTo.contact;
      blankAddress.phone = this.shipment.addressTo.phone;
      blankAddress.secondPhone = this.shipment.addressTo.secondPhone;
      blankAddress.email = this.shipment.addressTo.email;
      blankAddress.secondEmail = this.shipment.addressTo.secondEmail;
      this.shipment.addressTo = blankAddress;
      this.shipment.addressAccessPoint = undefined;
    }

    this.loadCourierServices();

    //Envelop
    if (this.shipment.shipPackTypeId === 1) {
      this.allPackagesEqual = true;
      let val = 0; // fixed weight
      if (isFrance()) {
        switch (this.shipment.courierId) {
          case 1:
            val = 0.5;
            break; //UPS
          case 2:
            val = 0.5;
            break; //FedEx
          case 3:
            val = 0.2;
            break; //TNT
          case 4:
            val = 0.3;
            break; //DHL
          default:
            val = 0.5;
            break;
        }
        this.packageNumberModified(1); //max 1 envelope
        this.changeShipmentWeight({ target: { value: val } });
      }
      if (isGermany() && this.shipment.courierId == 4) {
        val = 0.3;
        this.packageNumberModified(1); //max 1 envelope
        this.changeShipmentWeight({ target: { value: val } });
      } else if (isGermany() && this.shipment.courierId !== 4) {
        val = 0.5;
        this.packageNumberModified(1);
        this.changeShipmentWeight({ target: { value: val } });
      }
    }

    //Documents
    if (this.shipment.shipPackTypeId === 2) {
      this.allPackagesEqual = true;
      let val = 0; // fixed weight
      if (isFrance()) {
        switch (this.shipment.courierId) {
          case 1: //UPS
            val = 2.5;
            break;
          case 2: //FedEx
            val = 2.5;
            break;
          case 3: //TNT
            val = 3;
            break;
          case 4: //DHL
            val = 2;
            break;
          case 12: //CHRONOPOST
            val = 3;
            break;
          default:
            val = 2.5;
            break;
        }
        this.packageNumberModified(1); //max 1 envelope
        this.changeShipmentWeight({ target: { value: val } });
      } else if (isPoland()) {
        if (this.shipment.courierId === 4) {
          val = 1;
          this.packageNumberModified(1); //max 1 envelope
          this.changeShipmentWeight({ target: { value: val } });
        }
      }
    }

    this.$emit("courierModified");
  }

  get courierService(): CourierServiceDTO | null {
    const filteredCourierServices = this.courierServices.filter(
      (item: CourierServiceDTO) => {
        return item.idBusiness === this.shipment.courierServiceId;
      }
    );

    if (filteredCourierServices.length > 0) {
      return filteredCourierServices[0];
    } else {
      return null;
    }
  }

  set courierService(value: CourierServiceDTO | null) {
    if (value != null) {
      this.shipment.courierServiceId = value.idBusiness;
      this.shipment.courierServiceName = value.courierServiceName;
    } else {
      this.shipment.courierServiceId = 0;
      this.shipment.courierServiceName = "";
    }
  }

  courierServiceModified(item: CourierServiceDTO, manual = true) {
    this.courierService = item;
    if (
      manual &&
      this.shipment.mbeService &&
      this.isGel &&
      this.shipment.addressAccessPoint
    ) {
      const blankAddress = new AddressShipmentDTO();
      blankAddress.contact = this.shipment.addressTo.contact;
      blankAddress.phone = this.shipment.addressTo.phone;
      blankAddress.secondPhone = this.shipment.addressTo.secondPhone;
      blankAddress.email = this.shipment.addressTo.email;
      blankAddress.secondEmail = this.shipment.addressTo.secondEmail;
      this.shipment.addressTo = blankAddress;
      this.shipment.addressAccessPoint = undefined;
    }
    this.$emit("courierServiceModified");
  }
  handleTemplateSearch(search: any) {
    if (search === undefined || search === "" || search.length < 3) {
      return;
    }

    const searchInput = {
      search: search.toLowerCase(),
      page: 0,
      pageSize: 25
    } as SearchParams;

    ShipmentService.prototype
      .searchShipmentTemplates(
        searchInput,
        this.$store.getters["customer/info"].customerId,
        this.$store.getters.user.username
      )
      .then(res => {
        this.shipmentTemplates = res.templates;
      })
      .catch(reason => {
        this.$snotify.error(reason.response.data.message);
      });
  }
  loadTemplates() {
    ShipmentService.prototype
      .searchShipmentTemplates(
        undefined,
        this.$store.getters["customer/info"].customerId,
        this.$store.getters.user.username
      )
      .then(res => {
        this.shipmentTemplates = res.templates;
      })
      .catch(reason => {
        this.$snotify.error(reason.response.data.message);
      });
  }
  templateModified() {
    this.changeShipmentWeight({
      target: { value: this.selectedTemplate.weight }
    });
    this.shipment.shipmentPackages.forEach((pck, index) => {
      this.shipment.shipmentPackages[index].height = Number(
        this.selectedTemplate.height
      );
      this.shipment.shipmentPackages[index].width = Number(
        this.selectedTemplate.width
      );
      this.shipment.shipmentPackages[index].depth = Number(
        this.selectedTemplate.depth
      );
    });
    this.shipment.notes = this.selectedTemplate.content;
  }

  get courierAndCourierService(): CourierAndCourierService | null {
    const filteredCourierAndCourierServices = this.courierAndCourierServices.filter(
      (item: CourierAndCourierService) => {
        return (
          item.courierService.courierServiceName ===
            this.shipment.courierServiceName ||
          item.courierService.idCourierService ===
            this.shipment.courierServiceId ||
          item.courierService.idBusiness === this.shipment.courierServiceId
        );
      }
    );
    if (filteredCourierAndCourierServices.length > 0) {
      return filteredCourierAndCourierServices[0];
    } else {
      return null;
    }
  }

  set courierAndCourierService(value: CourierAndCourierService | null) {
    if (value != null) {
      this.shipment.courierId = value.courier.idMBEBusiness;
      this.shipment.courierName = value.courier.courierName;
      this.shipment.courierServiceId = value.courierService.idBusiness;
      this.shipment.courierServiceName =
        value.courierService.courierServiceName;
    } else {
      this.shipment.courierId = this.shipment.courierId
        ? this.shipment.courierId
        : 0;
      this.shipment.courierName = this.shipment.courierName
        ? this.shipment.courierName
        : null;
      this.shipment.courierServiceId = this.shipment.courierServiceId
        ? this.shipment.courierServiceId
        : 0;
      this.shipment.courierServiceName = this.shipment.courierServiceName
        ? this.shipment.courierServiceName
        : "";
    }
  }

  get isElinkShipment() {
    return (
      this.shipment &&
      this.shipment.source === "WEBSITE" &&
      this.shipment.shipmentSource === "API_SOAP"
    );
  }

  get showCourierSelection() {
    return this.$store.getters["customer/config"].canSelectCourier;
  }
  get showTemplates() {
    return this.$store.getters.customer.config.showDefaultPackageSettings;
  }

  get showOnlyCourierService() {
    return (
      this.$store.getters["customer/config"].canSelectCourierService &&
      !this.$store.getters["customer/config"].canSelectCourier
    );
  }

  courierAndCourierServiceModified(item: CourierAndCourierService) {
    if (item) {
      this.courier = item.courier;
      this.courierService = item.courierService;
      this.$emit("courierAndCourierServiceModified");
    }
  }

  onWineProductChange() {
    if (!this.isWineShipment) return;
    this.resetAllPackages();
  }

  created() {
    // package-types
    if (this.edition) {
      CustomerService.getCustomerPackTypes().then(res => {
        this.mbePackTypes = res.map((item: OnlineMbePackTypeDto) => {
          const translatedMbePackageType = {
            ...item
          } as OnlineMbePackTypeDef;
          translatedMbePackageType.translatedPackTypeDescription = this.$t(
            "mbePackageType_" + item.packtypeBusinessId
          ).toString();
          return translatedMbePackageType;
        });
        if (this.mbePackTypes?.length > 0 && !this.mbePackage) {
          const packagePresel = this.mbePackTypes.find(
            value => value.packtypeBusinessId === 3
          );
          //preselect package or first available
          this.mbePackageModified(
            packagePresel ? packagePresel : this.mbePackTypes[0]
          );
        }
      });

      this.loadCouriers().then(() => {
        if (this.canSelect.onlyCourierService) {
          this.loadCourierServices();
        }
      });

      this.updateSequence();
    }
  }

  get canSelect() {
    return {
      courier: this.$store.getters["customer/config"].canSelectCourier,
      courierService: this.$store.getters["customer/config"]
        .canSelectCourierService,
      onlyCourierService:
        this.$store.getters["customer/config"].canSelectCourierService &&
        !this.$store.getters["customer/config"].canSelectCourier
    };
  }

  @Watch("isTaxDutySectionEnabled", { immediate: true })
  async isTaxDutySectionEnabledChanged(status: boolean) {
    if (!this.edition && status) {
      await this.loadCourierServices();
    }
  }

  get isTaxDutySectionEnabled() {
    return this.$store.getters["shipment/enableTaxDutySection"] as boolean;
  }

  loadCouriers(cancelSource: any = undefined, force = false): Promise<any> {
    if (
      ((this.canSelect.courier ||
        this.canSelect.courierService ||
        this.isGel) &&
        !this.wineProductUS &&
        this.shipment.addressFrom.subcountryId) ||
      force
    ) {
      return PriceListService.getCouriers(
        this.shipment.addressFrom.subcountryId,
        this.shipment.addressTo.subcountryId,
        this.shipment.shipmentType,
        this.shipment.mbeServiceId,
        cancelSource
      ).then((res: CourierDTO[]) => {
        this.couriers = JSON.parse(JSON.stringify(res));

        if (
          this.autopilotEnabled &&
          this.enabledAutopilotCouriers &&
          this.enabledAutopilotCouriers.length > 0
        ) {
          this.couriers = this.couriers.filter(c => {
            return this.enabledAutopilotCouriers.find(
              enabled => enabled === c.idMBEBusiness
            );
          });
        }

        if (!this.detailsCalled) {
          return Promise.resolve();
        }

        if (this.couriers.length === 0) {
          // No couriers to select, ensure no courier is selected
          this.courier = null;
          this.$emit("resetCourier");
        } else if (this.couriers.length === 1) {
          // Only one courier to select, select it
          this.courier = this.couriers[0];
        } else {
          // If the actual selected courier is in the new loaded list
          // preselect it
          const filteredCouriers = this.couriers.filter((item: CourierDTO) => {
            return item.idCourier == this.shipment.courierId;
          });

          if (filteredCouriers.length == 1) {
            this.courier = filteredCouriers[0];
          }
        }
        return Promise.resolve();
      });
    } else {
      this.couriers = [];
      this.$emit("resetCourier");
      return Promise.resolve(null);
    }
  }

  loadCourierServices(
    cancelSource: any = undefined,
    force = false,
    packtypes?
  ): Promise<any> {
    if (this.wineProductUS) {
      return Promise.resolve(null);
    }
    let packs = packtypes;
    if (!packtypes) {
      packs = this.courierPackageTypes;
    }

    this.courierServices = [];
    if (this.canSelect.courierService || force || this.isGel) {
      if (this.courier != null) {
        const courierId = this.courier.idCourier
          ? this.courier.idCourier
          : this.courier.idMBEBusiness;
        return this.$store.cache
          .dispatch("cachemod/courierServices", {
            idCourier: courierId,
            subcountryFromId: this.shipment.addressFrom.subcountryId,
            subcountryToId: this.shipment.addressTo.subcountryId,
            shipmentType: this.shipment.shipmentType,
            courierPackageType:
              packs.length > 0
                ? packs[0].idMBEBusiness
                : this.shipment.courierShipPackTypeId,
            mbeService: this.shipment.mbeServiceId,
            cancelSource: cancelSource,
            autopilot: this.autopilotEnabled
          })
          .then((res: CourierServiceDTO[]) => {
            this.courierServices = res;
            const service = this.courierServices.find(
              val => val.idBusiness === this.shipment.courierServiceId
            );
            if (!service) {
              this.shipment.courierServiceId = 0;
              this.shipment.courierServiceName = "";
              if (
                this.courierServices.length !== 0 &&
                this.shipment.courierId !== CourierBusiness.GEL
              ) {
                const value = this.courierServices[0];
                this.shipment.courierServiceId = value.idBusiness;
                this.shipment.courierServiceName = value.courierServiceName;
              }
            }
          });
      } else {
        if (this.canSelect.onlyCourierService) {
          this.courierAndCourierServices = [];
          if (this.couriers.length > 0) {
            const [head, ...tail] = this.couriers;
            return this.loadCourierAndCourierServices(head, tail, cancelSource);
          }
        }
      }
    }
    this.$emit("resetCourierService");
    this.courierServices = [];
    return Promise.resolve(null);
  }

  loadCourierAndCourierServices(
    head: CourierDTO,
    tail: CourierDTO[],
    cancelSource: any = undefined
  ): Promise<any> {
    return PriceListService.getCourierServices(
      head.idCourier,
      this.shipment.addressFrom.subcountryId,
      this.shipment.addressTo.subcountryId,
      this.shipment.shipmentType,
      this.courierPackageTypes.length > 0
        ? this.courierPackageTypes[0].idMBEBusiness
        : this.shipment.courierShipPackTypeId,
      this.shipment.mbeServiceId,
      cancelSource
    ).then((res: CourierServiceDTO[]) => {
      res.forEach((courierService: CourierServiceDTO) => {
        this.courierAndCourierServices.push({
          courier: head,
          courierService: courierService,
          courierAndCourierServiceName: `${head.courierName} - ${courierService.courierServiceName}`
        });
      });

      if (tail.length > 0) {
        const [new_head, ...new_tail] = tail;
        return this.loadCourierAndCourierServices(new_head, new_tail);
      } else {
        return Promise.resolve(null);
      }
    });
  }

  @Debounce(600)
  packageNumberModified(value: number) {
    const packagesLen = this.shipment.shipmentPackages.length;
    if (value > packagesLen) {
      const diff = value - packagesLen;
      for (let i = 0; i < diff; i++) {
        this.shipment.shipmentPackages.push(new ShipmentPackageDTO());
      }
      this.updateSequence();
    } else if (value < packagesLen) {
      const diff = packagesLen - value;
      for (let i = 0; i < diff; i++) {
        this.shipment.shipmentPackages.pop();
      }
    }

    // Recalculate total weight
    this.adjustPackages();

    this.$emit("packageNumberChanged");
  }

  deletePackage(index: any) {
    const halfBeforeTheUnwantedElement = this.shipment.shipmentPackages.slice(
      0,
      index
    );
    const halfAfterTheUnwantedElement = this.shipment.shipmentPackages.slice(
      index + 1
    );
    this.shipment.shipmentPackages = halfBeforeTheUnwantedElement.concat(
      halfAfterTheUnwantedElement
    );
    if (
      this.specialPackagesCourierWeightList.length > 0 &&
      this.isWineShipment
    ) {
      this.specialPackagesCourierWeightList = this.specialPackagesCourierWeightList.filter(
        (el: any) => el.index !== index
      );
    }
    this.adjustPackages();

    this.$emit("packageNumberChanged");
  }

  duplicatePackage(shipmentPackage: ShipmentPackageDTO) {
    const pack = JSON.parse(JSON.stringify(shipmentPackage));
    if (this.shipment.shipmentId) pack.mbePackTrackingNumber = "";
    this.shipment.shipmentPackages.push(pack);
    this.adjustPackages();
    this.$emit("packageNumberChanged");
  }

  // for autopilot enabled stores, the couriers available to user are only the one returned
  // from first detail inside autopilotAvailableCouriers object
  setAutopilotCourierToCouriersList(couriers: CourierDTO[]) {
    this.couriers = couriers;
    this.loadCourierServices();
  }

  getCourierIdBusinessForCourierId(courierId: number): number {
    const filtered_couriers = this.couriers.filter(
      item => item.idMBEBusiness == courierId
    );

    if (filtered_couriers.length === 1) {
      return filtered_couriers[0].idMBEBusiness;
    } else {
      return 0;
    }
  }

  getCourierIdBusinessForCourier(courierId: number): number {
    const filtered_couriers = this.couriers.filter(
      item => item.idCourier == courierId
    );

    if (filtered_couriers.length === 1) {
      return filtered_couriers[0].idMBEBusiness;
    } else {
      return courierId;
    }
  }

  getCourierName() {
    if (this.edition) {
      return "Select";
    }
    if (this.autopilotCourierId === this.shipment.courierId) {
      return `${this.shipment.courierName} - ${this.$t("autopilot")}`;
    }
    return this.shipment.courierName;
  }

  getCourierServiceName() {
    if (this.edition) {
      return "Select";
    }
    return this.shipment.courierServiceName;
  }

  getCourierService() {
    return this.courierService;
  }

  getNoEditionPackType() {
    if (this.edition) {
      return "Select";
    }
    if (
      typeof this.shipment.shipPackType !== "undefined" &&
      this.shipment.shipPackType !== ""
    ) {
      return this.$t(
        "mbePackageType_" + this.shipment.shipPackTypeId
      ).toString();
    } else {
      return "";
    }
  }

  isErrorMaxShipmentWeight() {
    if (
      !smallerThanMaxShipmentWeight(this.totalWeightIncludingVolumetricWeight)
    ) {
      return true;
    } else {
      return false;
    }
  }

  isErrorNoShipmentWeight() {
    if (!notZero(this.totalWeightIncludingVolumetricWeight)) {
      return true;
    } else {
      return false;
    }
  }

  isErrorMultipackage() {
    if (!notMultipackageIfNotAllowed(this.shipment.shipmentPackages.length)) {
      return true;
    } else {
      return false;
    }
  }

  get courierValue() {
    if (this.autopilotCourierId === this.shipment.courierId) {
      return `${this.shipment.courierName} - ${this.$t("chosen_by_autopilot")}`;
    }
    return this.shipment.courierName;
  }

  get isPackTypeEnvelope() {
    return this.mbePackage?.packtypeBusinessId === 1;
  }

  get totalWeightIncludingVolumetricWeight() {
    const ret = this.shipment.shipmentPackages
      .map(item => {
        let max = Number(item.customerWeight);
        const volumetricWeight = Number(item.customerVolumetricWeight);
        if (volumetricWeight > max) max = volumetricWeight;
        return max;
      })
      .reduce((a, b) => a + b, 0);

    return ret;
  }

  get disableCourierSelection() {
    if (this.autopilotEnabled) return !this.edition || !this.detailsCalled;
    return !this.edition;
  }

  get disableCourierServiceSelection() {
    if (this.autopilotEnabled) return !this.edition || !this.detailsCalled;
    return !this.edition;
  }

  onInputFocus(e) {
    e.target.setSelectionRange(0, 9999);
  }

  cloneFrom(other: ShipmentPackageDTO) {
    const item = {
      packTrackingNumber: other.packTrackingNumber,
      mbePackTrackingNumber: other.mbePackTrackingNumber,
      sequence: other.sequence,
      courierWeight: other.courierWeight,
      courierVolumetricWeight: other.courierVolumetricWeight,
      courierTaxedWeight: other.courierTaxedWeight,
      customerWeight: other.customerWeight,
      customerVolumetricWeight: other.customerVolumetricWeight,
      customerTaxedWeight: other.customerTaxedWeight,
      depth: other.depth,
      width: other.width,
      height: other.height,
      itemsNumber: other.itemsNumber,
      specialItemsNumber: other.specialItemsNumber,
      trackingLastStatusCourier: other.trackingLastStatusCourier,
      trackingLastStatusMbeName: other.trackingLastStatusMbeName,
      trackingLastStatusMbeId: other.trackingLastStatusMbeId,
      trackingDate: other.trackingDate,
      trackingSignature: other.trackingSignature,
      //--packageCourierId: other.packageCourierId,
      //--packageCourierName: other.packageCourierName,
      currentPosition: other.currentPosition,
      barCode: other.barCode,
      sent: other.sent,
      overweight: other.overweight,
      addHandling: other.addHandling,
      oversize: other.oversize,
      delivered: other.delivered,
      seen: other.seen
    };
    return item;
  }

  @Watch("isPalletIDS")
  isPalletIDSChange() {
    if (this.isPalletIDS) {
      this.$store.cache
        .dispatch("cachemod/getSpecificPackTypes", {
          courierId: this.shipment.courierId
        })
        .then(res => {
          this.specificPacktypes = res.map(el => {
            return {
              label: el.description,
              value: el.code
            };
          });
          if (this.specificPacktypes.length > 0) {
            if (!this.specificPackTypeSelected) {
              const defaultPackType = this.specificPacktypes.find(
                (el: any) => el.value === "FP"
              );
              this.specificPackTypeSelected = defaultPackType
                ? defaultPackType.value
                : this.specificPacktypes[0].value;
            }
          }
        });
      this.$store.cache
        .dispatch("cachemod/getHandlingInstructions", {})
        .then(res => {
          this.handlingInstructions = res.map(el => {
            return {
              optionServiceName: el.name,
              optionServiceBusinessId: el.handlingId
            };
          });
        });
    } else {
      this.specificPackTypeSelected = null;
      this.specificPacktypes = [];
      this.handlingInstructions = [];
    }
  }

  setIdsPalletDefaultValues(curPackage: ShipmentPackageDTO) {
    if (!isGermany()) {
      return;
    }
    if (
      this.specificPackTypeSelected &&
      this.specificPackTypeSelected !== "" &&
      this.edition
    ) {
      curPackage["specificPacktype"] = this.specificPackTypeSelected;

      this.$emit("packageDimensionsChanged");
      this.adjustPackages();
    }
  }

  resetIdsPalletDefaultValues(curPackage: ShipmentPackageDTO) {
    if (!isGermany()) {
      return;
    }
    curPackage["specificPacktype"] = null;

    this.$emit("packageDimensionsChanged");
    this.adjustPackages();
  }

  @Watch("specificPackTypeSelected", {})
  specificPacktypeChange() {
    if (this.specificPackTypeSelected && this.specificPackTypeSelected !== "") {
      this.shipment.shipmentPackages.forEach(value =>
        this.setIdsPalletDefaultValues(value)
      );
    } else {
      this.shipment.shipmentPackages.forEach(value =>
        this.resetIdsPalletDefaultValues(value)
      );
    }
  }

  updateSequence() {
    this.shipment.shipmentPackages = this.shipment.shipmentPackages.map(
      (obj, i) => ({ ...obj, sequence: i + 1 })
    ) as ShipmentPackageDTO[];
  }

  getCourierLabel(courier: any) {
    if (this.autopilotCourierId === courier.idMBEBusiness) {
      return `${courier.courierName} - ${this.$t("chosen_by_autopilot")}`;
    } else {
      return courier.courierName;
    }
  }

  get isCourierIDS() {
    return this.shipment.courierId === 14;
  }

  get isPalletIDS() {
    return this.isCourierIDS && this.mbePackage.packtypeBusinessId === 4;
  }

  getAddressDistance() {
    const shipment: any = this.shipment;
    if (
      shipment.addressFrom.address === "" ||
      shipment.addressFrom.countryName === "" ||
      shipment.addressFrom.city === "" ||
      shipment.addressTo.address === "" ||
      shipment.addressTo.countryName === "" ||
      shipment.addressTo.city === ""
    ) {
      this.$alerts.danger(this.$t("calculate_distance_missing_fields"));
    } else {
      this.$alerts
        .confirm(this.$t("calculate_distance_warning"))
        .then((resp: boolean) => {
          if (resp) {
            this.$store.cache
              .dispatch("cachemod/getAddressDistance", {
                addressFrom: this.shipment["addressFrom"],
                addressTo: this.shipment["addressTo"]
              })
              .then(value => {
                this.googleDistance = ShipmentService.prototype.parseDistanceResult(
                  value
                );
                this.calculatedDistance =
                  this.googleDistance.inMeters > 0
                    ? this.googleDistance.inMeters / 1000
                    : this.googleDistance.inMeters;
                shipment.distanceFromTo = this.calculatedDistance;
                this.$emit("packageNumberChanged");
                this.getDistanceModalVisible = true;
              })
              .catch(reason => {
                return alertDangerReason(reason, this);
              });
          }
        });
    }
  }

  getAddress(type: string) {
    const shipment: any = this.shipment;
    const address: any = shipment[type];
    const secondAddress: string =
      address.secondAddress === "" ? "" : `${address.secondAddress}, `;
    const thirdAddress: string =
      address.thirdAddress === "" ? "" : `${address.thirdAddress}, `;
    const zipCode: string =
      address.zipCode === "" ? "" : `${address.zipCode}, `;
    return `${address.address}, ${secondAddress}${thirdAddress}${zipCode}${address.city}, ${address.countryName}`;
  }

  updateNetworkCodes(data: any) {
    this.gelNetworkCodes = data;
  }

  gelPointSelected(data: any) {
    const networkSelected = this.gelNetworkCodes.find(
      (network: any) => network.code === data.gelNetworkCode
    );

    if (networkSelected) {
      PriceListService.getCouriers(
        this.shipment.addressFrom.subcountryId,
        this.shipment.addressTo.subcountryId,
        this.shipment.shipmentType,
        this.shipment.mbeServiceId
      ).then(res => {
        this.couriers = res;
        if (!this.courier || !this.courier.idMBEBusiness) {
          const courierToSelect = this.couriers.find(
            (courier: CourierDTO) =>
              courier.idMBEBusiness === networkSelected!.courierBusinessId
          );
          if (courierToSelect) {
            this.courierModified(courierToSelect, false);
            if (!this.courierService || !this.courierService.idBusiness) {
              PriceListService.getCourierServices(
                courierToSelect.idCourier
              ).then((res: any) => {
                const courierServices = res;

                let courierServiceId = networkSelected!.serviceBusinessId;
                if (this.courier.idMBEBusiness === CourierBusiness.GLS) {
                  if (this.totalShipmentWeight <= 3.0) {
                    courierServiceId = GLSServiceBusiness.PUDO_LIGHT_EXPRESS;
                  } else {
                    courierServiceId = GLSServiceBusiness.PUDO_EXPRESS;
                  }
                }

                const courierServiceToSelect = courierServices.find(
                  (courierService: any) =>
                    courierService.idBusiness === courierServiceId
                );
                if (courierServiceToSelect) {
                  this.courierServiceModified(courierServiceToSelect, false);
                }
              });
            }
          }
        } else {
          let courierServiceId = networkSelected!.serviceBusinessId;
          if (this.courier.idMBEBusiness === CourierBusiness.GLS) {
            if (this.totalShipmentWeight <= 3.0) {
              courierServiceId = GLSServiceBusiness.PUDO_LIGHT_EXPRESS;
            } else {
              courierServiceId = GLSServiceBusiness.PUDO_EXPRESS;
            }
          }

          const courierServiceToSelect = this.courierServices.find(
            (courierService: any) =>
              courierService.idBusiness === courierServiceId
          );
          if (courierServiceToSelect) {
            this.courierServiceModified(courierServiceToSelect, false);
          }
        }
      });
    }

    this.$emit("gelPointSelectedAddress", data);
  }

  get wineProductUS() {
    return this.wineProduct === "wine_us" || this.wineProduct === "spirits_us";
  }
}
